// @see mylw-uat.nexcess-internal.workers.dev
import prodTemplate from './prod';
import type { AppConfigI } from './example';

const uat: AppConfigI = {
	...prodTemplate,
	cart: {
		...prodTemplate.cart,
		checkoutURL: 'https://stg-marketing.liquidweb.com/cart/checkout',
		configURL: 'https://stg-marketing.liquidweb.com/configuration',
	},
	gaTrackerId: 'G-RWVHZPXV4N',
	gtmContainerId: 'GTM-PQFRHRZH',
	hosts: {
		...prodTemplate.hosts,
		www: 'stg-marketing.liquidweb.com',
	},
	openId: {
		client_id: 'mylw-uat-cp',
		authority: 'https://login.liquidweb.com',
		accessTokenExpiringNotificationTime: 1200,
	},
	headsUpDisplay: true,
};

export default uat;
